import { StyledListButton, StyledMobileButton, StyledMobileMenuItem } from '../ui';
import { useDispatch } from 'react-redux';
import { openLinkAccountDialog } from '../../../../actions';
import { ListItemText } from '@material-ui/core';

export default function LinkAccountMenuItem({ isMobile = false }) {
  const dispatch = useDispatch();

  const openDialog = () => {
    dispatch(openLinkAccountDialog());
  };

  if (isMobile) {
    return (
      <StyledMobileMenuItem>
        <StyledMobileButton type="button" onClick={openDialog}>
          <ListItemText primary="Link Account" />
        </StyledMobileButton>
      </StyledMobileMenuItem>
    );
  }

  return (
    <StyledListButton onClick={openDialog}>
      <span>Link Account</span>
    </StyledListButton>
  );
}
